module.exports = __webpack_public_path__ + "static/img3-e8e13acc94be3661492d1b02ad3f6ed4.jpg";